import { environment } from '../../../../environments/environment';

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const BidApiResources = {
  list: createUrl('bids'),
  widgetList: createUrl('bids/search'),
  search: createUrl('bids/search'),
  create: createUrl('bids/create'),
  addBidder: createUrl('bids/add/bidder'),
  removeBidder: createUrl('bids/remove/bidder'),
  changeStatus: createUrl('bids/change/status'),
  archiveBid: createUrl('bids'),
  copyRebid: createUrl('bids'),
  activateRebid: createUrl('bids'),
  rebidHistory: createUrl('bids'),
  relatedJobs: createUrl('bids'),
  onHold: createUrl('bids/on-hold'),
  updateUnionOptions: createUrl('bids/update-union-options'),
  copyProposal: createUrl('bids/cloneProposal'),
  updateBidOffice: createUrl('bids/update-bid-office'),
  getTakeoff: createUrl('takeoffs/by_bid'),
  detail: createUrl('bids'),
  update: createUrl('bids'),
  delete: createUrl('bids'),
  deleteMultiple: createUrl('bids/delete/multiple'),
  deleteAvailability: createUrl('bids/delete/availability'),
  getPageGroup: createUrl('takeoffs/pagesGroups/getByTakeoff'),
  getDrawing: createUrl('bids/{bid_id}/drawings'),
  getDrawingPages: createUrl('bids/{document_id}/drawing_pages'),
  deleteDrawing: createUrl('takeoffs/remove/drawing'),
  getMediaFiles: createUrl('bid-job-media'),
  createMediaFiles: createUrl('bid-job-media/create'),
  //Takeoff Drawing endpoints
  createFolderDrawing: createUrl('document/create-folder'),
  getIncompleteDrawings: createUrl('bids/{bid_id}/incomplete_drawings'),
  requestTakeoff: createUrl('request/takeoffs'),
  // Import endpoints
  downloadSampleFile: createUrl('bids/import/sample'),
  uploadImportFile: createUrl('bids/import/upload'),
  validateImportData: createUrl('bids/import/validate'),
  executeImport: createUrl('bids/import/execute'),
  updateSiteInfo: createUrl('bids/site-info'),
  getJobsiteRequirements: createUrl('jobsite/requirements'),
  getJobsiteAccesses: createUrl('jobsites/accesses'),
  createJobsiteAccess: createUrl('jobsites/accesses'),
  getJobsiteParking: createUrl('jobsites/parking'),
  createJobsiteParking: createUrl('jobsites/parking'),
  createBidJobsite: createUrl('bids/jobsite'),
  getBidJobsites: createUrl('bids/{bid_id}/jobsites'),
  updateDescription: createUrl('bids'),
  updateBidDueDate: createUrl('bids/{bid_id}/update/due-date'),
  // Manual scale correction / reset for individual bid drawing pages (Drawings tab, outside
  // of any takeoff — see BidDrawingPageController on the backend).
  updateDrawingPageScale: createUrl('bid-drawing-pages/{id}/scale'),
  resetDrawingPageScale: createUrl('bid-drawing-pages/reset-scale'),
  deleteDrawingPage: createUrl('bid-drawing-pages/{id}'),
  getProposalsByBid: createUrl('bids/get-proposal'), // Used as bids/get-proposal/{bid_id}
};
